import { render } from "./LandingPageAgf.vue?vue&type=template&id=31382162&scoped=true"
import script from "./LandingPageAgf.vue?vue&type=script&lang=js"
export * from "./LandingPageAgf.vue?vue&type=script&lang=js"

import "./LandingPageAgf.vue?vue&type=style&index=0&id=31382162&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31382162"]])

export default __exports__